import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MPPMenuItem } from '@usf/ngrx-tools/lib/model/mpp-menu-item';

@Component({
  selector: 'app-sub-menu-modal',
  templateUrl: './sub-menu-modal.component.html',
  styleUrls: ['./sub-menu-modal.component.scss'],
})
export class SubMenuModalComponent {
  @Output() dismissEvent = new EventEmitter<void>();
  @Output() submitEvent = new EventEmitter<MPPMenuItem>();

  @Input() items: MPPMenuItem[];
  constructor() {}

  close() {
    this.dismissEvent.next();
  }

  select(item: MPPMenuItem) {
    this.submitEvent.emit(item);
  }
}
